import { render, staticRenderFns } from "./group_person.vue?vue&type=template&id=931e9f3e&scoped=true"
import script from "./group_person.vue?vue&type=script&lang=js"
export * from "./group_person.vue?vue&type=script&lang=js"
import style0 from "./group_person.vue?vue&type=style&index=0&id=931e9f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931e9f3e",
  null
  
)

export default component.exports